export default __webpack_public_path__ + "static/media/DSC09634.caadf9f9.JPG";